import { render, staticRenderFns } from "./OptionalData.vue?vue&type=template&id=0f324d86&scoped=true&"
import script from "./OptionalData.vue?vue&type=script&lang=js&"
export * from "./OptionalData.vue?vue&type=script&lang=js&"
import style0 from "./missing-data.scss?vue&type=style&index=0&id=0f324d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f324d86",
  null
  
)

export default component.exports